// extracted by mini-css-extract-plugin
export default {"featuredInterviews":"Featured_featuredInterviews__79k57","gridRow":"Featured_gridRow__zBTJz","title":"Featured_title__y1HVJ","item":"Featured_item__a10P7"};